<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center mb-0 cardheadercustom">
      <h5 class="mb-0">
        {{ $t("Last Test Information") }}
      </h5>
      <!-- @click="handleShowTest" -->
      <b-button
        v-if="testData != null"
        variant="primary"
        class="btn-sm"
        :to="{
          name: 'testreport',
          params: { id: $route.params.id, testid: testData._id },
        }"
      ><feather-icon icon="SearchIcon" />
      </b-button>
      <small class="text-muted w-100">{{ testData
        ? new Date(testData.createdAt).toLocaleDateString($i18n.locale, {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
        : $t("Not Done")
      }}</small>
    </b-card-header>
    <b-card-body>
      <ul class="list-unstyled">
        <li style="">
          <span class="align-middle">{{ $t("Attention:") }} </span>
          <b-badge
            v-if="testData"
            :variant="testData ? gradeColor(testData.attention) : 'dark'"
          >
            {{ testData ? numberToGrade(testData.attention) : "" }}
          </b-badge>
          <span v-else> - </span>
          <span />
        </li>
        <li>
          <span class="align-middle">{{ $t("Logic:") }} </span>
          <b-badge
            v-if="testData"
            :variant="testData ? gradeColor(testData.logic) : 'dark'"
          >
            {{ testData ? numberToGrade(testData.logic) : "" }}
          </b-badge>
          <span v-else> - </span>
          <span />
        </li>
        <li>
          <span class="align-middle">{{ $t("Concentration:") }} </span>
          <b-badge
            v-if="testData"
            :variant="testData ? gradeColor(testData.concentration) : 'dark'"
          >
            {{ testData ? numberToGrade(testData.concentration) : "" }}
          </b-badge>
          <span v-else> - </span>
          <span />
        </li>
        <li>
          <span class="align-middle">{{ $t("Memory:") }} </span>
          <b-badge
            v-if="testData"
            :variant="testData ? gradeColor(testData.memory) : 'dark'"
          >
            {{ testData ? numberToGrade(testData.memory) : "" }}
          </b-badge>
          <span v-else> - </span>
          <span />
        </li>
      </ul>
      <div v-if="programData.active">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          :variant="
            canReadExercise &&
              programData.groups.attention.group &&
              programData.groups.logic.group &&
              programData.groups.concentration.group &&
              programData.groups.memory.group &&
              programData.active
              ? 'primary'
              : 'secondary'
          "
          block
          class="buttoncustom"
          :to="{ name: 'exercises-detail', params: {} }"
          :disabled="
            canReadExercise &&
              programData.groups.attention.group &&
              programData.groups.logic.group &&
              programData.groups.concentration.group &&
              programData.groups.memory.group &&
              programData.active &&
              isActive
              ? false
              : true
          "
        >
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon
              size="1.5x"
              icon="AlignJustifyIcon"
              class="mr-1"
            /><span>{{ $t("Set Operations") }}</span>
          </div>
        </b-button>
        <b-button
          :disabled="isProgramResetting"
          block
          class="buttoncustom"
          variant="info"
          @click="resetProgram"
        >
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon
              size="1.5x"
              icon="RotateCcwIcon"
              class="mr-1"
            />
            <span>{{ $t("Reset Program") }}</span>
          </div>
        </b-button>
      </div>
      <div v-else>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          :variant="canCreateTest ? 'primary' : 'secondary'"
          :disabled="!canCreateTest || !isActive || isGbtStarting"
          block
          class="buttoncustom"
          @click="canCreateTest ? confirmBeforeTest() : null"
        >
          <div class="d-flex justify-content-center align-items-center">
            <feather-icon
              size="1.5x"
              icon="ActivityIcon"
              class="mr-1"
            /><span>{{ $t("Apply GBT") }}</span>
          </div>
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BBadge,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import {
  guardSubscriptionAction,
  ActionRequirement,
} from '@/libs/subscriptionActionGuard'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
  },
  props: {
    testData: {
      type: Object,
    },
    programData: {
      type: Object,
      required: true,
    },
    grade: String,
    isFirm: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    // subjectID: { type: String, default: "" },
  },
  data() {
    return {
      isGbtStarting: false,
      isProgramResetting: false,
    }
  },
  computed: {
    userID() {
      return this.$route.params.id
    },
    canCreateTest() {
      return this.$can('create', `${this.isFirm ? 'F' : 'S'}.Test`)
    },
    canReadExercise() {
      return this.$can('read', `${this.isFirm ? 'F' : 'S'}.Exercise`)
    },
  },
  methods: {
    handleShowTest() {
      // this.$router.push({ name: "test-detail", params: { id: this.userID } });
      console.log(this.testData)
    },
    numberToGrade(number) {
      const index = number > 0 ? number - 1 : number
      const values = ['E', 'D', 'C', 'B', 'A']
      return values[index]
    },
    gradeColor(number) {
      const index = number > 0 ? number - 1 : number
      const values = ['danger', 'warning', 'primary', 'info', 'success']
      return values[index]
    },
    async confirmBeforeTest() {
      if (this.isGbtStarting) return
      this.isGbtStarting = true

      try {
        const decision = await guardSubscriptionAction({
          requirement: ActionRequirement.SUBSCRIPTION_AND_STANDING,
          source: 'report-gbt-start',
        })
        if (!decision.allowed) return

        const { isConfirmed } = await this.$swal(
          {
            title: this.$t('Program will be applied!'),
            text: [
              this.$t('When you accept you will be taken to the test page.')
                + this.$t('Program will be applied after test is completed.'),
            ],
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#34bde6',
            cancelButtonText: this.$t('Cancel'),
            confirmButtonColor: '#de39a5',
            confirmButtonText: this.$t('I will start the test'),
          },
          {},
        )
        if (isConfirmed) await this.$router.push({ name: 'test-testing', params: {} })
      } finally {
        this.isGbtStarting = false
      }
    },
    async resetProgram() {
      if (this.isProgramResetting) return
      this.isProgramResetting = true

      try {
        const decision = await guardSubscriptionAction({
          requirement: ActionRequirement.SUBSCRIPTION_ONLY,
          source: 'report-program-reset',
        })
        if (!decision.allowed) return

        const { isConfirmed } = await this.$swal(
          {
            title: this.$t('Program will be reset!'),
            text: this.$t(
              'Program will be reset and the subject will need to be tested again before applying a new program.',
            ),
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#34bde6',
            cancelButtonText: 'Vazgeç',
            confirmButtonColor: '#de39a5',
            confirmButtonText: this.$t('I will reset'),
          },
          {},
        )
        if (!isConfirmed) return

        const response = await axios.post(`/subject/${this.userID}/reset`)
        if (response.data.status) {
          await this.$swal({
            title: this.$t('Reset Program'),
            text: this.$t('Your program has been reset.'),
            icon: 'success',
            confirmButtonColor: '#7367F0',
          })
          window.location.href = `/clientlist/${this.userID}`
        } else {
          await this.$swal({
            title: this.$t('Error!'),
            text: this.$t('Your program has not been reset.'),
            icon: 'error',
            confirmButtonColor: '#7367F0',
          })
        }
      } finally {
        this.isProgramResetting = false
      }
    },
  },
}
</script>

<style scoped>
.list-unstyled {
  margin: 0 0 5px 0;
}
.cardheadercustom {
  padding-top: 5px;
  padding-bottom: 0;
}
.buttoncustom {
  padding: 5px;
}
.cardheadercustom > h5 {
  margin: 0;
  padding: 0;
}
.list-unstyled > li > span:first-child {
  width: 50%;
}
.list-unstyled > li {
  display: flex;
  justify-content: space-between;
  margin: 2px 0 2px 0;
}
</style>
